<div class="modal-overlay" *ngIf="showModalTipoAcao" (click)="!loading && fecharModal()">
  <div class="box-novo-tipo-acao" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">
          <i class="fa fa-balance-scale"></i> Novo Tipo Ação
        </h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close" [disabled]="loading"></button>
      </div>
    </div>
    <hr>
    <div class="modal-body p-0">
      <div class="row">
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="descricaoTipoAcao">Descrição</label>
            <input type="text" class="form-control" name="descricao" id="descricaoTipoAcao"
                   [(ngModel)]="tipoAcao.descricao" placeholder="Digite a descrição" [disabled]="loading">
          </div>
        </div>
      </div>
    <div class="row mt-3">
      <div class="col-md-12 d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-light" (click)="fecharModal()" [disabled]="loading">
          Cancelar
        </button>
        <button type="button" class="btn btn-primary px-4 d-flex align-items-center gap-2" (click)="salvar()" [disabled]="loading">
          <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ loading ? 'Salvando...' : 'Salvar' }}
        </button>
      </div>
    </div>
    </div>
  </div>
</div>
